import { IAspectRatioe } from "pages/imageCreator/components/ExtraAction";
export const aspectRatioes: IAspectRatioe[] = [
  {
    label: "Square",
    value: "1:1",
  },
  {
    label: "Portrait (9:16)",
    value: "9:16",
  },
  {
    label: "Landscape (16:9)",
    value: "16:9",
  },
  {
    label: "Mobile portrait (3:4)",
    value: "3:4",
  },
  {
    label: "Mobile landscape (4:3)",
    value: "4:3",
  },
];